module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Tools-14736bf2249b0c4a8bbf51ccc2c88701.svg";